import { render, staticRenderFns } from "./JcdcUtilityMenu.vue?vue&type=template&id=454cd968"
import script from "./JcdcUtilityMenu.vue?vue&type=script&lang=ts"
export * from "./JcdcUtilityMenu.vue?vue&type=script&lang=ts"
import style0 from "./JcdcUtilityMenu.vue?vue&type=style&index=0&id=454cd968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports